import { createApiHandler } from './handler';

const clients = {
  apiClient: null,
  path: '/admin/clients',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getAddressById(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/address/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createAddress(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/address`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateAddress(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/address/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteAddress(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/address/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async impersonate(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/impersonate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getWallet(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/${id}/wallet`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async adjustWallet(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/wallet/adjust`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default clients;
